import axiosInstance from '../Redux/APInterceptors';
import { getToken, storeSessionFlags } from './localStorage';

/**
 * Ask the server who the signed in account is and keep its staff flag beside
 * the tokens (sprint 17). Called right after login, and again whenever the
 * signed in app opens, so a session that started before this code shipped
 * picks the flag up without signing out, and a change to an account's rights
 * shows on its next visit.
 *
 * Resolves true when the flag was stored, false when there is no session or
 * the server did not answer with one. Never throws.
 */
export const refreshSessionFlags = async (): Promise<boolean> => {
  const access = getToken();
  if (!access) {
    return false;
  }
  try {
    const response = await axiosInstance.get('auth/user-info');
    const data = response?.data;
    if (
      !data ||
      typeof data.username !== 'string' ||
      typeof data.is_staff !== 'boolean'
    ) {
      return false;
    }
    return storeSessionFlags(data.username, data.is_staff, access);
  } catch (error) {
    return false;
  }
};
